import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DcRuntimeApi } from '@api/bff/openapi/endpoints/dc-runtime-api';
import type {
  AppendMeasurementDto,
  DcRuntimeViewModel
} from '@api/bff/openapi/models';
import { bffApiClient } from '@api/bff/client';
import { dcRuntimeKeys } from '../constants';

type AppendMeasurementParams = {
  id: string;
  dto: AppendMeasurementDto;
};

export const useAppendMeasurement = () => {
  const queryClient = useQueryClient();
  const dcRuntimeApi = new DcRuntimeApi(undefined, undefined, bffApiClient);

  return useMutation<DcRuntimeViewModel, Error, AppendMeasurementParams>({
    mutationFn: async ({ id, dto }: AppendMeasurementParams) => {
      const response = await dcRuntimeApi.apiDcRuntimeIdMeasurementPost({
        id,
        appendMeasurementDto: dto
      });
      return response.data;
    },

    onSuccess: (data, variables) => {
      if (data && variables.id) {
        queryClient.setQueryData(dcRuntimeKeys.byId(variables.id), data);
      }
    }
  });
};
